export const initialState = {
  selectedFilterTag: null,
};

export function SELECT_FILTER_TAG(nextState, { selectedFilterTag }) {
  nextState.selectedFilterTag = selectedFilterTag;
}
